/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import store from 'features/store';
import { Form, Button, Spinner } from 'react-bootstrap';
import { MyAccountMenuList, removeSideBar, ToggleSideBar } from '../MyAccountMenuList';
import { connect } from 'react-redux';

import { MyAccountService } from 'shared/services';
import { ToasterMessage } from 'shared/toast/toast';
import { logout } from 'shared/settings/auth';

import './NotificationPreferences.scss';
import { AddAriaLabel } from 'shared/utils/AddAriaLabel';
import { Loader } from 'shared/hoc/loader/Loader';
/**


@Author Karthik

@param

@return html code for Notification Preferences

**/

class NotificationPreferences extends Component {
    constructor(props) {
        super(props);
        this.toasterMessage = createRef();
        this.notificationForm = {
            bidConfirmEmail: { value: false, error: '', validators: [] },
            bidConfirmSms: { value: false, error: '', validators: [] },
            outBidConfirmEmail: { value: false, error: '', validators: [] },
            outBidConfirmSms: { value: false, error: '', validators: [] },
            itemWonEmail: { value: false, error: '', validators: [] },
            itemWonSms: { value: false, error: '', validators: [] },
            watchListEmail: { value: false, error: '', validators: [] },
            paymentNotificationEmail: { value: false, error: '', validators: [] },
            saleClosingNotification: { value: false, error: '', validators: [] },
            marketingEmailNotification: { value: false, error: '', validators: [] }
        }
        this.state = {
            pageLoading: true,
            notificationForm: Object.assign({}, this.notificationForm),
            formValid: false,
            pageMode: 'Add',
            updateIds: { bidConfirmId: undefined, outBidConfirmId: undefined, itemWonId: undefined, watchListId: undefined, paymentNotifyId: undefined, saleClosingId: undefined, marketingEmailId: undefined },
            loading: false,
            apiMessage: { type: 'success', message: 'Saved', show: false },
            onLoad: false
        }
    }

    componentDidMount() {
        this.getRequiredData();
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        this.windowResizeHandle();
        window.addEventListener('resize', this.windowResizeHandle);
    }

    componentDidUpdate() {
        window.addEventListener('resize', this.windowResizeHandle);
        if (!this.state.pageLoading && !this.state.onLoad) {
            this.setState({onLoad: true});
        }
    }

    getRequiredData() {
        MyAccountService.getNotificationPreference().then(
            response => {
                const data = response.data.data;
                const pageMode = data.length === 0 ? 'Add' : 'Update';
                const bidConfirm = data.filter(x => x.preferencetype === 'BIDCONFIRM');
                const outBid = data.filter(x => x.preferencetype === 'OUTBID');
                const itemWon = data.filter(x => x.preferencetype === 'BIDWON');
                const watchlist = data.filter(x => x.preferencetype === 'WATCHLIST');
                const payment = data.filter(x => x.preferencetype === 'CREDITCARD');
                const saleClosing = data.filter(x => x.preferencetype === 'AUCTIONENDING');
                const marketingEmail = data.filter(x => x.preferencetype === 'MARKETINGEMAIL');

                this.setState({
                    ...this.state,
                    pageMode: pageMode,
                    updateIds: {
                        bidConfirmId: bidConfirm.length > 0 ? bidConfirm[0]?.id : undefined,
                        outBidConfirmId: outBid.length > 0 ? outBid[0]?.id : undefined,
                        itemWonId: itemWon.length > 0 ? itemWon[0]?.id : undefined,
                        watchListId: watchlist.length > 0 ? watchlist[0]?.id : undefined,
                        paymentNotifyId: payment.length > 0 ? payment[0]?.id : undefined,
                        saleClosingId: saleClosing.length > 0 ? saleClosing[0]?.id : undefined,
                        marketingEmailId: marketingEmail.length > 0 ? marketingEmail[0]?.id : undefined
                    },
                    notificationForm: {
                        ...this.state.notificationForm,
                        bidConfirmEmail: {
                            ...this.state.notificationForm.bidConfirmEmail,
                            value: bidConfirm[0]?.email === 1
                        },
                        bidConfirmSms: {
                            ...this.state.notificationForm.bidConfirmSms,
                            value: bidConfirm[0]?.mobile === 1
                        },
                        outBidConfirmEmail: {
                            ...this.state.notificationForm.outBidConfirmEmail,
                            value: outBid[0]?.email === 1
                        },
                        outBidConfirmSms: {
                            ...this.state.notificationForm.outBidConfirmSms,
                            value: outBid[0]?.mobile === 1
                        },
                        itemWonEmail: {
                            ...this.state.notificationForm.itemWonEmail,
                            value: itemWon[0]?.email === 1
                        },
                        itemWonSms: {
                            ...this.state.notificationForm.itemWonSms,
                            value: itemWon[0]?.mobile === 1
                        },
                        watchListEmail: {
                            ...this.state.notificationForm.watchListEmail,
                            value: watchlist[0]?.email === 1
                        },
                        paymentNotificationEmail: {
                            ...this.state.notificationForm.paymentNotificationEmail,
                            value: payment[0]?.email === 1
                        },
                        saleClosingNotification: {
                            ...this.state.notificationForm.saleClosingNotification,
                            value: saleClosing[0]?.mobile === 1
                        },
                        marketingEmailNotification: {
                            ...this.state.notificationForm.marketingEmailNotification,
                            value: marketingEmail[0]?.email === 1
                        }
                    },
                    pageLoading: false,
                    loading: false
                });
            }
        ).catch(error => {
            // TODO: Error message handle
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(this.props.history, false);
                removeSideBar();
            } else {
                this.setState({
                    pageLoading: false,
                    loading: false
                });
            }
        });
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName = "notificationForm", checkbox = true) => {
        let controlError = '';

        if (checkbox) {
            event.target.value = event.target.checked;
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
    }

    submit = () => {
        this.setState({
            loading: true
        }, () => {
            const formValue = this.state.notificationForm;
            const updateIds = this.state.updateIds;
            const data = {
                "data": [
                    {
                        "id": updateIds.bidConfirmId,
                        "preferencetype": "BIDCONFIRM",
                        "email": formValue.bidConfirmEmail.value === true || formValue.bidConfirmEmail.value === "true" ? true : false,
                        // "mobile": formValue.bidConfirmSms.value === true || formValue.bidConfirmSms.value === "true" ? true : false,
                        "mobile": false,
                        "web": true,
                        "buyerid": this.props.user.id
                    },
                    {
                        "id": updateIds.outBidConfirmId,
                        "preferencetype": "OUTBID",
                        "email": formValue.outBidConfirmEmail.value === true || formValue.outBidConfirmEmail.value === "true" ? true : false,
                        "mobile": formValue.outBidConfirmSms.value === true || formValue.outBidConfirmSms.value === "true" ? true : false,
                        "web": true,
                        "buyerid": this.props.user.id
                    },
                    {
                        "id": updateIds.itemWonId,
                        "preferencetype": "BIDWON",
                        "email": formValue.itemWonEmail.value === true || formValue.itemWonEmail.value === "true" ? true : false,
                        "mobile": formValue.itemWonSms.value === true || formValue.itemWonSms.value === "true" ? true : false,
                        "web": true,
                        "buyerid": this.props.user.id
                    },
                    {
                        "id": updateIds.watchListId,
                        "preferencetype": "WATCHLIST",
                        "email": formValue.watchListEmail.value === true || formValue.watchListEmail.value === "true" ? true : false,
                        // "mobile": formValue.bidConfirmSms.value === true || formValue.bidConfirmSms.value === "true" ? true : false,
                        "mobile": false,
                        "web": true,
                        "buyerid": this.props.user.id
                    },
                    {
                        "id": updateIds.paymentNotifyId,
                        "preferencetype": "CREDITCARD",
                        "email": formValue.paymentNotificationEmail.value === true || formValue.paymentNotificationEmail.value === "true" ? true : false,
                        "mobile": false,
                        "web": true,
                        "buyerid": this.props.user.id
                    },
                    {
                        "id": updateIds.saleClosingId,
                        "preferencetype": "AUCTIONENDING",
                        "email": false,
                        "mobile": formValue.saleClosingNotification.value === true || formValue.saleClosingNotification.value === "true" ? true : false,
                        "web": false,
                        "buyerid": this.props.user.id
                    }
                ]
            };
            if (formValue.marketingEmailNotification.value) {
                data.data.push({
                    "id": updateIds.marketingEmailId,
                    "preferencetype": "MARKETINGEMAIL",
                    "email": formValue.marketingEmailNotification.value === true || formValue.marketingEmailNotification.value === "true" ? true : false,
                    "mobile": false,
                    "web": true,
                    "buyerid": this.props.user.id
                })
            }
            if (this.state.pageMode === 'Add') {
                MyAccountService.addNotificationPreference(data).then(
                    response => {
                        this.toasterMessage.current.showMessage({ type: 'success', message: 'Saved' });
                        this.getRequiredData();
                    }
                ).catch(error => {
                    this.setState({
                        loading: false
                    });
                    this.toasterMessage.current.showMessage({ type: 'danger', message: error.message });
                });
            } else {
                MyAccountService.updateNotificationPreference(data).then(
                    response => {
                        this.toasterMessage.current.showMessage({ type: 'success', message: 'Saved' });
                        this.getRequiredData();
                    }
                ).catch(error => {
                    this.setState({
                        loading: false
                    });
                    this.toasterMessage.current.showMessage({ type: 'danger', message: error.message });
                });
            }
        });
    }

    windowResizeHandle = () => {
        ToggleSideBar();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeHandle);
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }


    render() {
        return (
            <div className="notification-preferences-main  mb-5 mt-5">
                <AddAriaLabel loading={this.state.onLoad} config={[
                    {id: "email-checkbox1", label: "bid Confirmation Notification Email"},
                    {id: "sms-checkbox1", label: "bid Confirmation Notification Sms"},
                    {id: "email-checkbox2", label: "out Bid Notification Email"},
                    {id: "sms-checkbox2", label: "out Bid Notification Sms"},
                    {id: "email-checkbox3", label: "item Won Notification Email"},
                    {id: "sms-checkbox3", label: "item Won Notification Sms"},
                    {id: "email-checkbox4", label: "watchList Notification Email"},
                    {id: "sms-checkbox4", label: "watchList Notification Email"},
                    {id: "email-checkbox5", label: "payment Method Notification Email"},
                    {id: "sms-checkbox5", label: "payment Method Notification Email"},
                    {id: "app-checkbox6", label: "sale Close Notification App"},
                    {id: "email-checkbox7", label: "marketing Email Notification"}
                ]}/>
                {
                    this.state.pageLoading ?
                        <Loader />:
                        <div className="main-content">
                            <div className="notification-preferences d-flex justify-content-center">
                                <div className="content-width" style={{ width: '100%', overflowX: 'scroll'}}>
                                    <div className="header d-flex align-items-center justify-content-between">
                                        <div className="left-side">Notification Preferences</div>
                                        <div className="right-side d-flex">
                                            <div>App</div>
                                            <div>Email</div>
                                            <div>SMS</div>
                                        </div>
                                    </div>
                                    <div className="content-body">
                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Bid Confirmation Notification</div>
                                            <div className="right-side d-flex">
                                            <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox1`}
                                                        name="bidConfirmEmail"
                                                        aria-label='bid Confirmation Notification Email'
                                                        checked={this.state.notificationForm.bidConfirmEmail.value === true || this.state.notificationForm.bidConfirmEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check className="invisible"
                                                        custom
                                                        type="checkbox"
                                                        id={`sms-checkbox1`}
                                                        name="bidConfirmSms"
                                                        aria-label='bid Confirmation Notification Sms'
                                                        checked={this.state.notificationForm.bidConfirmSms.value === true || this.state.notificationForm.bidConfirmSms.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Out Bid Notification</div>
                                            <div className="right-side d-flex">
                                            <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox2`}
                                                        name="outBidConfirmEmail"
                                                        aria-label='out Bid Notification Email'
                                                        checked={this.state.notificationForm.outBidConfirmEmail.value === true || this.state.notificationForm.outBidConfirmEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`sms-checkbox2`}
                                                        name="outBidConfirmSms"
                                                        aria-label='out Bid Notification Sms'
                                                        checked={this.state.notificationForm.outBidConfirmSms.value === true || this.state.notificationForm.outBidConfirmSms.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Item Won Notification</div>
                                            <div className="right-side d-flex">
                                            <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox3`}
                                                        name="itemWonEmail"
                                                        aria-label='item Won Notification Email'
                                                        checked={this.state.notificationForm.itemWonEmail.value === true || this.state.notificationForm.itemWonEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`sms-checkbox3`}
                                                        name="itemWonSms"
                                                        aria-label='item Won Notification Sms'
                                                        checked={this.state.notificationForm.itemWonSms.value === true || this.state.notificationForm.itemWonSms.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Watchlist Notification</div>
                                            <div className="right-side d-flex">
                                            <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox4`}
                                                        name="watchListEmail"
                                                        aria-label='watchList Notification Email'
                                                        checked={this.state.notificationForm.watchListEmail.value === true || this.state.notificationForm.watchListEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check className="invisible"
                                                        custom
                                                        type="checkbox"
                                                        id={`sms-checkbox4`}
                                                        name="watchListEmail"
                                                        aria-label='watchList Notification Email'
                                                        checked={this.state.notificationForm.watchListEmail.value === true || this.state.notificationForm.watchListEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Payment Method Notification</div>
                                            <div className="right-side d-flex">
                                            <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox5`}
                                                        name="paymentNotificationEmail"
                                                        aria-label='payment Method Notification Email'
                                                        checked={this.state.notificationForm.paymentNotificationEmail.value === true || this.state.notificationForm.paymentNotificationEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check className="invisible"
                                                        custom
                                                        type="checkbox"
                                                        id={`sms-checkbox5`}
                                                        name="paymentNotificationEmail"
                                                        aria-label='payment Method Notification Email'
                                                        checked={this.state.notificationForm.paymentNotificationEmail.value === true || this.state.notificationForm.paymentNotificationEmail.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Sale Closing Notification</div>
                                            <div className="right-side d-flex">
                                            <div style={{marginRight: '35px'}}>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`app-checkbox6`}
                                                        name="saleClosingNotification"
                                                        aria-label='sale Close Notification App'
                                                        checked={this.state.notificationForm.saleClosingNotification.value === true || this.state.notificationForm.saleClosingNotification.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                
                                                <div>
                                                    <Form.Check
                                                        className="invisible"
                                        
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check className="invisible"
                                             
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between my-20">
                                            <div className="left-side">Marketing Email Notification</div>
                                            <div className="right-side d-flex">
                                                <div>
                                                    <Form.Check className="invisible" />
                                                </div>
                                                <div>
                                                    <Form.Check
                                                        custom
                                                        type="checkbox"
                                                        id={`email-checkbox7`}
                                                        name="marketingEmailNotification"
                                                        aria-label='marketing Email Notification'
                                                        checked={this.state.notificationForm.marketingEmailNotification.value === true || this.state.notificationForm.marketingEmailNotification.value === 'true' ? true : false}
                                                        onChange={this.onInputValidation}
                                                    />
                                                </div>
                                                <div>
                                                    <Form.Check className="invisible" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-center">
                                            <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="buttons">
                                                {
                                                    this.state.loading ?
                                                        <Button variant="secondary" disabled>
                                                            Save {' '} <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                                        </Button> :
                                                        <Button variant="secondary" className='ctbids-btn' aria-label='click to save notification settings' onClick={this.submit}>Save</Button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(NotificationPreferences);